import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/app/main.service.ts' );

import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';
import {Folder, FourDService, Project, TransformType} from '4d-mapper';
import { CesiumMapService } from '../service/map-viewer.service';
import { XsIdentityInterface } from '../xs/interfaces/identify.interface';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
declare var Dropbox
@Injectable({
  providedIn: 'root'
})
export class MainService implements XsIdentityInterface {

  __ID = null;

  searchFilesFolder: Subject<any> = new Subject<any>();
  searchFilesFolderWithoutGlobal: Subject<any> = new Subject<any>();
  newProjectCreatedSubject: Subject<Project> = new Subject<Project>();
  static GOOGLE_DRIVE= "GOOGLE DRIVE";
  static DROPBOX= "DROPBOX";
  rootFolder: Folder;
  selectedFolder: Folder;
  isDialog: boolean;
  adHocF: TransformType[];
  createNewFolder: Subject<Folder> = new Subject<Folder>();
 // openGoogleDriveSub: Subject<any> = new Subject<any>();
  openDropBoxSub: Subject<any> = new Subject<any>();
  uploadFilesSub: Subject<any> = new Subject<any>();
  dropFilesSub: Subject<any> = new Subject<any>();
  renameSub: Subject<Folder> = new Subject<Folder>();
  moveFolderSub: Subject<Folder> = new Subject<Folder>();
  folderDeleteSub: Subject<Folder> = new Subject<Folder>();
  startAdHocFolderSub: Subject<any> = new Subject<any>();
  googleFolder: Folder;
  dropboxFolder: Folder;
  dataType: 'Dataset' | 'Transform';
  fileListComponent: any;
  isOver: boolean;
  uploadExistingFiles : Subject<any> = new Subject<any>();


  constructor(private fourD:FourDService, public cesiumMap: CesiumMapService, public applicationEvents: XsApplicationEventsService ) { 
    DEBUG.log ( '/app/main.service.ts', 'CONSTRUCTOR', [ fourD, cesiumMap ] );
    this.__ID = XsIdentityInterface.__init(this);
  }

  newFolder(parent?: Folder) {
    this.createNewFolder.next(parent);
  }
/*
  openGoogleDrive() {
    this.openGoogleDriveSub.next();
  }
  openDropBox(){
    this.openDropBoxSub.next();
  }*/
  uploadFiles(e) {
    this.uploadFilesSub.next(e);
  }

  dropFile(e) {
    this.dropFilesSub.next(e);
  }

  rename(f: Folder) {
    this.renameSub.next(f);
  }

  moveFolder(f: Folder) {
    this.moveFolderSub.next(f);
  }

  folderDelete(f: Folder) {
    this.folderDeleteSub.next(f);
  }

  startAdHocFolder(f: Folder, xform: TransformType) {
    this.startAdHocFolderSub.next({
      folder : f,
      transformType : xform
      });
  }

  
  
  pickDropbox(){

    
    var options = {

      // Required. Called when a user selects an item in the Chooser.
      success:  (files) => {
      
        if(files && files.length > 0){
          files.forEach(file => 
            this.openDropBoxSub.next(file)
          )
        }

      },

        cancel: function () {

      },

      linkType: 'preview', // or "direct"

      multiselect: false, // or true

      
      folderselect: true, // or true

    
    };

      Dropbox.choose(options);
  }
}
